import { GET_ANIMAL_TYPES_LOADING, GET_ANIMAL_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getAnimalTypesSuccess = payload => {
    return ({
        type: GET_ANIMAL_TYPES_SUCCESS,
        payload
    })
}

export const getAnimalTypesAsync = payload => dispatch => {
    return client.service('animal-types').find()
		.then((response) => {
            dispatch(getAnimalTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}